var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-img',{attrs:{"src":_vm.link}}),_vm._v(" "+_vm._s(_vm.name)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }